/**
 * PublicLayout Component
 *
 * Minimal layout wrapper for public/marketing routes.
 * Includes:
 * - Sticky AppHeader with navigation (adapts for auth state)
 * - Main content outlet
 * - Footer
 * - Scroll-to-top on route change
 *
 * Used by: Public routes (landing, marketing, legal)
 */

import { Outlet } from 'react-router-dom';
import { AppHeader } from './app-header';
import { Footer } from './app-footer';
import { useScrollToTop } from '@/hooks/use-scroll-to-top';

/**
 * Public layout component
 * Wraps public/marketing routes with header and footer
 */
export const PublicLayout = () => {
  // Scroll to top on route change (consistent with AppLayout)
  useScrollToTop();

  return (
    <>
      {/* Sticky header for consistent navigation */}
      <header className="sticky top-0 z-40 border-b bg-background">
        <AppHeader />
      </header>

      {/* Main content area - child routes render here */}
      <main className="min-h-screen">
        <Outlet />
      </main>
      {/* Footer - appears on all public pages */}
      <Footer />
    </>
  );
};

